<template>
  <v-container></v-container>
</template>

<script>
export default {
  name: 'Create'
}
</script>

<style scoped>

</style>
